import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker, Dropdown, Gapped, MenuHeader, MenuItem, MenuSeparator } from '@skbkontur/react-ui';
import { ValidationContainer, ValidationWrapper } from '@skbkontur/react-ui-validations';
import { checkDateInRange, convertPeriodToISO, convertToDatePicker, getCaption, validateDateRange, } from './PeriodFilter.helpers';
export const PeriodFilter = ({ initialPeriod, onPeriodChange, onTodayClick, onAllTimeClick, }) => {
    const [begin, setBegin] = useState(convertToDatePicker(initialPeriod?.begin));
    const [end, setEnd] = useState(convertToDatePicker(initialPeriod?.end));
    const [lastEdited, setLastEdited] = useState(null);
    const validationRef = useRef(null);
    const now = dayjs().format('DD.MM.YYYY');
    const handleClickToday = () => {
        setBegin(now);
        setEnd(null);
        onTodayClick && onTodayClick(now);
    };
    const handleClickAllTime = () => {
        setBegin(null);
        setEnd(null);
        onAllTimeClick && onAllTimeClick();
    };
    const handleBeginChange = (value) => {
        setBegin(value);
        setLastEdited('begin');
    };
    const handleEndChange = (value) => {
        setEnd(value);
        setLastEdited('end');
    };
    const handleClose = () => {
        if (validateDateRange(begin, end)) {
            return;
        }
        handleClickAllTime();
    };
    useEffect(() => {
        (async () => {
            const valid = validationRef.current ? await validationRef.current?.validate() : false;
            if (!valid) {
                return;
            }
            onPeriodChange(convertPeriodToISO(begin, end));
        })();
    }, [begin, end]);
    return (_jsx(ValidationContainer, { ref: validationRef, children: _jsxs(Dropdown, { caption: getCaption(begin, end, now), width: 260, onClose: handleClose, disablePortal: true, "data-tid": "periodFilter", children: [_jsx(MenuItem, { onClick: handleClickToday, children: "\u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F" }), _jsx(MenuItem, { onClick: handleClickAllTime, children: "\u0437\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F" }), _jsx(MenuSeparator, {}), _jsx(MenuHeader, { children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434" }), _jsx(MenuHeader, { children: _jsxs(Gapped, { gap: 4, children: [_jsx(ValidationWrapper, { validationInfo: lastEdited === 'begin' || lastEdited === null
                                    ? checkDateInRange({
                                        value: begin,
                                        type: lastEdited === null ? 'immediate' : 'lostfocus',
                                        message: '',
                                        maxDate: end || undefined,
                                    })
                                    : null, children: _jsx(DatePicker, { value: begin, onValueChange: handleBeginChange, width: 112, "data-tid": "periodFilterBegin" }) }), "\u2013", _jsx(ValidationWrapper, { validationInfo: lastEdited === 'end' || lastEdited === null
                                    ? checkDateInRange({
                                        value: end,
                                        type: lastEdited === null ? 'immediate' : 'lostfocus',
                                        message: '',
                                        minDate: begin || undefined,
                                    })
                                    : null, children: _jsx(DatePicker, { value: end, onValueChange: handleEndChange, width: 112, "data-tid": "periodFilterEnd" }) })] }) })] }) }));
};
